<template>
  <div class="app-shell">
    <aside class="app-sidebar">
      <div class="app-sidebar__brand">
        <img src="@/assets/logo-branca.png" alt="LC3 Market" class="app-sidebar__logo">
        <span class="app-sidebar__tag">admin</span>
      </div>
      <Navbar/>
    </aside>
    <div class="app-main">
      <header class="app-topbar">
        <div class="app-topbar__heading">
          <router-link v-if="backTo" :to="{ name: backTo }" class="app-back-btn" title="Voltar">
            <i class="bi bi-arrow-left"></i>
          </router-link>
          <h1>{{ title }}</h1>
        </div>
        <div class="app-topbar__actions">
          <slot name="actions"/>
        </div>
      </header>
      <main class="app-content">
        <slot/>
      </main>
    </div>
  </div>
</template>
<script>
import Navbar from './Navbar.vue';

export default {
  name: 'AppLayout',
  components: {
    Navbar
  },
  props: {
    title: { type: String, default: '' },
    // Nome da rota para o botão de voltar no cabeçalho (páginas de detalhe).
    backTo: { type: String, default: null },
  },
}
</script>
<style scoped>
.app-shell {
  display: flex;
  align-items: flex-start;
  min-height: 100vh;
}

.app-sidebar {
  width: 240px;
  flex-shrink: 0;
  background: var(--sidebar-bg);
  padding: 1.5rem 1rem;
  position: sticky;
  top: 0;
  height: 100vh;
  overflow-y: auto;
}

.app-sidebar__brand {
  padding: 0 0.5rem;
  margin-bottom: 1.5rem;
}

.app-sidebar__logo {
  width: 100%;
}

.app-sidebar__tag {
  display: inline-block;
  margin-top: 0.5rem;
  padding: 0.15em 0.6em;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  color: #cbb8ec;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.app-main {
  flex: 1;
  min-width: 0;
}

.app-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding: 1.5rem 2rem;
  background: var(--surface);
  border-bottom: 1px solid var(--border-color);
}

.app-topbar__heading {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.app-topbar__heading h1 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 600;
  color: var(--text-strong);
}

.app-back-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 50%;
  background: var(--surface-muted);
  color: var(--text);
  text-decoration: none;
  transition: background 0.15s ease;
}

.app-back-btn:hover {
  background: var(--border-color);
  color: var(--text-strong);
}

.app-content {
  padding: 2rem;
}

@media (max-width: 768px) {
  .app-shell {
    flex-direction: column;
  }

  .app-sidebar {
    width: 100%;
    height: auto;
    position: static;
  }

  .app-topbar,
  .app-content {
    padding: 1.25rem;
  }
}
</style>
